import { useState } from 'react';
import {
  Box,
  Grid,
  useTheme,
  useMediaQuery,
  Drawer,
  IconButton,
  Typography,
  AppBar,
  Toolbar,
  Paper,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';

import AlertsSidebar from './components/AlertsSidebar';
import AlertDetailPanel from './components/AlertDetailPanel';
import { Application } from './types/application';
import STATUS_COLORS from '../../constants/statusColors'; // ★ 컬러 오브젝트 import

const AdminAlertsPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [selectedApplication, setSelectedApplication] = useState<Application | null>(null);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const handleSelectApplication = (application: Application) => {
    setSelectedApplication(application);
    if (isMobile) {
      setDrawerOpen(false);
    }
  };

  return (
    <Box
      sx={{
        flexGrow: 1,
        bgcolor: '#f8fafd',
        minHeight: '100vh',
      }}
    >
      {isMobile && (
        <AppBar
          position="sticky"
          elevation={0}
          sx={{
            bgcolor: STATUS_COLORS['신청완료'],
            color: '#fff',
            borderBottom: '1.5px solid #e0e7ef',
          }}
        >
          <Toolbar sx={{ minHeight: 56 }}>
            <IconButton edge="start" color="inherit" onClick={() => setDrawerOpen(true)}>
              <MenuIcon />
            </IconButton>
            <Typography variant="h6" sx={{ fontWeight: 800, letterSpacing: '-1.5px', ml: 1 }}>
              알림톡 수동 전송
            </Typography>
          </Toolbar>
        </AppBar>
      )}

      <Grid container sx={{ minHeight: 'calc(100vh - 0px)' }}>
        {/* 좌측 신청자 리스트 (데스크탑일 때만 보임) */}
        {!isMobile && (
          <Grid
            item
            xs={12}
            sm={4}
            md={3}
            sx={{
              borderRight: '1.5px solid #e0e7ef',
              bgcolor: '#fbfbfc',
              p: 0,
              height: '100vh',
              minWidth: 280,
              maxWidth: 360,
              boxShadow: '2px 0 16px 0 #d6e0f522',
            }}
          >
            <Box sx={{ height: '100%', overflow: 'auto' }}>
              <AlertsSidebar onSelect={handleSelectApplication} selected={selectedApplication} />
            </Box>
          </Grid>
        )}

        {/* 모바일 Drawer */}
        {isMobile && (
          <Drawer
            anchor="left"
            open={drawerOpen}
            onClose={() => setDrawerOpen(false)}
            PaperProps={{
              sx: {
                width: 310,
                borderRadius: '0 16px 16px 0',
                bgcolor: '#fbfbfc',
                borderRight: '1.5px solid #e0e7ef',
                boxShadow: '4px 0 20px #1976d225',
              },
            }}
          >
            <AlertsSidebar onSelect={handleSelectApplication} selected={selectedApplication} />
          </Drawer>
        )}

        {/* 우측 상세 패널 */}
        <Grid
          item
          xs={12}
          sm={8}
          md={9}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'stretch',
            p: { xs: 1, md: 4 },
            bgcolor: '#f8fafd',
            minHeight: '100vh',
          }}
        >
          <Paper
            elevation={0}
            sx={{
              flex: 1,
              borderRadius: 4,
              bgcolor: '#fff',
              p: { xs: 1.5, sm: 3, md: 4 },
              boxShadow: '0 2px 24px 0 #d6e0f511',
              border: '1.5px solid #e0e7ef',
              minHeight: { xs: 480, md: 640 },
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <AlertDetailPanel application={selectedApplication} />
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AdminAlertsPage;
